import React from "react";
import { Paper, Typography, Box, Rating } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { motion } from "framer-motion";

const ReviewItem = ({ item, index }) => {
  // Calculate a delay based on the item's index
  const delay = index * 0.1;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      style={{ display: "flex", justifyContent: "center" }} // Center the review items
    >
      <Paper
        elevation={3}
        sx={{
          backgroundColor: "black", // Set background color to black
          color: "magenta", // Set text color to magenta
          border: "1px solid black",
          boxShadow: "0 0 8px 2px white", // Add white blur around the border
          textAlign: "center",
          margin: "20px",
          padding: "20px",
          fontFamily: "cursive",
          display: "inline-block",
          width: "300px",
        }}
      >
        <Typography variant="h5" component="h2">
          {item.name}
        </Typography>
        <Rating name="read-only" value={item.rating} readOnly />
        <Typography variant="body1">{item.description}</Typography>
      </Paper>
    </motion.div>
  );
};

const ReviewsPage = ({ items }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <>
      <Typography
        variant="h4"
        sx={{
          color: "magenta", // Change color to magenta for a vibrant look
          textAlign: "center",
          my: 4,
          fontWeight: "bold", // Make the font bold
          textTransform: "uppercase", // UPPERCASE letters for emphasis
          fontFamily: "Arial, sans-serif", // Use a more modern font family
          letterSpacing: "0.1rem", // Add some letter spacing for a sophisticated touch
          textShadow: "2px 2px 4px rgba(0,0,0,0.2)", // Add a subtle shadow for depth
        }}
      >
        Client Experiences
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: matches ? "row" : "column",
          justifyContent: "center", // Center the review items horizontally
          flexWrap: "wrap", // Allow items to wrap as needed
          gap: "20px", // Add gap between items for better spacing
          overflowX: "auto",
          p: 3,
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {items.map((item, index) => (
          <ReviewItem key={index} item={item} index={index} />
        ))}
      </Box>
    </>
  );
};

export default ReviewsPage;
